import React from "react";

const FacebookIcon = props => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>facebook</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="facebook"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="flogo-RGB-HEX-Blk-144" fill="#363636" fillRule="nonzero">
        <path
          d="M22.675,0 L1.33333333,0 C0.596953667,-4.50902501e-17 9.01805001e-17,0.596953667 0,1.33333333 L0,22.6833333 C0.0091239944,23.413196 0.603413605,24.000057 1.33333333,24 L12.8333333,24 L12.8333333,14.7183333 L9.70333333,14.7183333 L9.70333333,11.0866667 L12.82,11.0866667 L12.82,8.42 C12.82,5.32 14.7133333,3.63166667 17.4866667,3.63166667 C18.4202028,3.62859938 19.3532249,3.6758903 20.2816667,3.77333333 L20.2816667,7 L18.3666667,7 C16.8666667,7 16.57,7.715 16.57,8.76333333 L16.57,11.0866667 L20.1666667,11.0866667 L19.7,14.7183333 L16.57,14.7183333 L16.57,24 L22.675,24 C23.4048853,23.9954523 23.9954523,23.4048853 24,22.675 L24,1.33333333 C24.0000143,0.600195798 23.4081232,0.00458210946 22.675,0 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export default FacebookIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/FacebookIcon.js